// Copyright (c) 2017 Deere & Company

import SearchFilters from '../../../shared/state/search-filters';

export const getDefaultState = () =>
    new SearchFilters({
        filterBy: '',
        query: '',
        sortBy: ['registrationDate'],
        sortDirection: 'DESC'
    });



// WEBPACK FOOTER //
// ./src/product/products-by-customer/state/search-filters.js